import styled from "styled-components";

const StyledCSVReader = styled.div`
  .input-container {
    position: relative;
    width: 570px;
    height: 40px;
    background: var(--color-contrast-white);
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: inset -1px 0 0 0 var(--color-neutral-300),
      inset 0 -1px 0 0 var(--color-neutral-300),
      inset 1px 0 0 0 var(--color-neutral-300),
      inset 0 2px 0 0 var(--color-action-hover);
    font-size: 14px;
    cursor: pointer;
  }

  .button-upload {
    width: 30%;
    height: 100%;
    font-size: 14px;
    background-color: var(--color-neutral-200);
    box-shadow: inset -1px 0 0 0 var(--color-neutral-300),
      inset 0 -1px 0 0 var(--color-neutral-300),
      inset 1px 0 0 0 var(--color-neutral-300),
      inset 0 2px 0 0 var(--color-action-hover);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--color-action-default);
    font-weight: bold;
  }

  label {
    line-height: 1.5rem;
    font-size: 12px;
    font-weight: var(--font-weight-semibold);
    text-transform: uppercase;
    color: var(--color-contrast-brand);
  }

  span {
    margin-left: 10px;
  }

  p {
    padding-left: 3px;
    font-size: 14px;
  }
`;

export default StyledCSVReader;
